import { useMutation } from '@tanstack/react-query';
import { setPartnerPassword } from '../services/partners';

export const useActivatePartnerAccountMutation = (options = {}) => {
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    ...restOptions,
    mutationFn: async ({ partnerId, password }) => {
      const result = await setPartnerPassword({ partnerId, password });
      if (!result.success) {
        throw new Error(result.message || 'Failed to activate partner account');
      }
      return result;
    },
    onSuccess: async (...args) => {
      await onSuccess?.(...args);
    },
    onError: (...args) => {
      onError?.(...args);
    },
  });
};
